import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Phone,
  Email,
  LocationOn,
  Facebook,
  Instagram,
  LinkedIn,
  ArrowUpward,
  School,
  MenuBook,
  Send,
  ChevronRight
} from '@mui/icons-material';
import { FaTiktok } from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate(); // <-- for programmatic navigation

  const handleNavigateCourses = () => {
    navigate('/courses'); // change to "/lead-form" if needed
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      alert(`Thank you for subscribing with: ${email}`);
      setEmail('');
    }
  };

  return (
    <footer className="bg-[#0F111A] text-white">
      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#FFC107]">Online Quran & Islamic Institute</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <LocationOn className="text-[#FFC107] mr-3 mt-1 flex-shrink-0" fontSize="small" />
                <span className="text-gray-300 text-sm">3rd floor, kiyani plaza murree road, Rawalpindi</span>
              </div>
              <div className="flex items-center">
                <Phone className="text-[#FFC107] mr-3 flex-shrink-0" fontSize="small" />
                <span className="text-gray-300 text-sm">+92 339 155 2155</span>
              </div>
              <div className="flex items-center">
                <Email className="text-[#FFC107] mr-3 flex-shrink-0" fontSize="small" />
                <span className="text-gray-300 text-sm">ceo@onlinequranandislamicinstitue.com</span>
              </div>

              {/* Social Media */}
              <div className="flex gap-3 pt-4">
                {[
                  { Icon: Facebook, label: "Facebook", link: "https://www.facebook.com/profile.php?id=61582353170339&mibextid=ZbWKwL" },
                  { Icon: LinkedIn, label: "LinkedIn", link: "https://www.linkedin.com/in/online-quran-and-islamic-institute-354869393?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" },
                  { Icon: Instagram, label: "Instagram", link: "https://www.instagram.com/inst.onlinequranislamic?utm_source=qr&igsh=cjlpOXJieDF6a210" },
                  { Icon: FaTiktok, label: "Tiktok", link: "http://tiktok.com/@onlinequranandisl7" }
                ].map(({ Icon, label, link }, index) => (
                  <a
                    key={index}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-gray-800 hover:bg-[#FFC107] hover:text-gray-900 w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300"
                    aria-label={label}
                  >
                    <Icon fontSize="small" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { text: 'About ', path: '/about' },
                { text: 'Our Scholars', path: '/lead-form' },
                { text: 'Courses', path: '/courses' },
                { text: 'Contact Us', path: '/lead-form' }
              ].map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    className="text-gray-300 hover:text-[#FFC107] transition-colors duration-300 flex items-center text-sm group"
                  >
                    <ChevronRight className="mr-2 text-[#FFC107] opacity-0 group-hover:opacity-100" fontSize="small" />
                    {item.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Resources</h4>
            <ul className="space-y-3">
              {[
                { icon: <School fontSize="small" />, text: 'Online Courses', path: '/courses' },
                { icon: <School fontSize="small" />, text: 'Kids Learning', path: '/courses' },
                { icon: <MenuBook fontSize="small" />, text: 'Quran Studies', path: '/courses' },
              ].map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    className="text-gray-300 hover:text-[#FFC107] transition-colors duration-300 flex items-center text-sm group"
                  >
                    <span className="mr-2">{item.icon}</span>
                    {item.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Newsletter</h4>
            <p className="text-gray-300 text-sm mb-4">
              Subscribe for updates on new courses and events.
            </p>
            <form onSubmit={handleSubmit} className="space-y-3">
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="bg-gray-800 text-white p-3 rounded-lg w-full focus:outline-none focus:ring-1 focus:ring-[#FFC107] text-sm pr-10"
                  required
                />
                <button
                  type="submit"
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[#FFC107] hover:bg-yellow-600 text-gray-900 p-1.5 rounded transition-colors duration-300"
                  aria-label="Subscribe"
                >
                  <Send fontSize="small" />
                </button>
              </div>
              <p className="text-gray-400 text-xs justify-center">
                We respect your privacy.
              </p>
            </form>
          </div>
        </div>
      </div>


      <div className="border-t border-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Changed flex-col md:flex-row to just flex-col for total centering */}
          <div className="flex flex-col items-center justify-center gap-4">

            <div className="text-center">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} Online Quran and Islamic Institute. All rights reserved.
              </p>

              {/* Centered the link container */}
              <div className="flex justify-center gap-6 mt-3">
                <Link
                  to="/terms-of-use"
                  className="text-gray-400 hover:text-[#FFC107] transition-colors duration-300 text-xs hover:underline"
                >
                  Terms of Use
                </Link>

                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-[#FFC107] transition-colors duration-300 text-xs hover:underline"
                >
                  Privacy Policy
                </Link>
              </div>
            </div>

          

      {/* Navigate Button */}
      <button
        onClick={handleNavigateCourses} // navigate to /courses
        className="bg-gray-800 hover:bg-[#FFC107] hover:text-gray-900 w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-300"
        aria-label="Go to Courses"
      >
        <ArrowUpward fontSize="small" />
      </button>
    </div>
        </div >
      </div >
    </footer >
  );
};

export default Footer;